import { render, staticRenderFns } from "./access_tutors.vue?vue&type=template&id=4a635d20"
import script from "./access_tutors.vue?vue&type=script&lang=js"
export * from "./access_tutors.vue?vue&type=script&lang=js"
import style0 from "./access_tutors.vue?vue&type=style&index=0&id=4a635d20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports